import { createSlice } from "@reduxjs/toolkit";

const storedLanguage = localStorage.getItem("selectedLanguage");
const validLanguages = ["en", "mr", "hi"];
const defaultLanguage = validLanguages.includes(storedLanguage)
  ? storedLanguage
  : "mr";

const initialState = {
  selectedLanguage: defaultLanguage,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      const lang = action.payload;
      if (validLanguages.includes(lang)) {
        console.log("Language changed to:", lang);
        localStorage.setItem("selectedLanguage", lang);
        state.selectedLanguage = lang;
      }
    },
  },
});

export const { changeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
